const $ = require("jquery");
import LookupTable from "../../components/lookupTable/index";
import run from "../../utilities/run";
import { isPresent } from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import render from "../../utilities/render";
import {
  prepareDataToSendController,
  isEdit,
  buildExport,
  doAjax,
  pushFilterSessionCacheState,
  retriveCriteriaObjectByOperation,
  retriveCriteriaObjectByKey,
  isNew,
  isDeleteView,
  isOnlyLookupDataUpdate
} from "../../utilities/filtersutil";
import { rulesLookupFieldDropdown } from "./filter/rulesLookupFieldDropdown.js";
import { actionOptions } from "./filter/actionOptions.js";
const _ = require("underscore");
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";

let actionCellDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html");
let actionCellDropdownItemTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html");
let actionHeaderDropdownTemplate = require("../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html");
let detailLinkTemplate = require("./html/detailLinkTemplate.html");
let actionList = actionOptions;

const targetSelector = "#lookup-order-hold-rules";

run(targetSelector, () => {
  const entryElement = $(targetSelector);
  const dataTableComponentData = entryElement.data("rules-data");

  const viewRulesDetailURL = entryElement.data("view-details-url");
  const filterSearchUrl = entryElement.data("filter-search-url");
  const releaseUrl = entryElement.data("release-url");
  const updateRuleUrl = entryElement.data("update-url");
  const generateExportUrl = entryElement.data("export-url");
  const bulkReleaseRuleUrl = entryElement.data("bulk-release-rule-url");

  const shouldCheckCache = entryElement.data("should-check-cache");

  const savedViews = entryElement.data("saved-views");
  const saveViewURL = entryElement.data("save-view-url");
  const deleteViewURL = entryElement.data("delete-view-url");

  let submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  let exportModal = new buildExport();

  const criteriaObjectFromServer = entryElement.data("filter-criteria-from-server");
  let targetObject = "";
  let totalRecordCount = 0;
  let lookupFieldDropdown = rulesLookupFieldDropdown;
  let selectedRows = "";

  //Need to map back from ruleAttr to specific key
  if (shouldCheckCache) {
    const key = retriveCriteriaObjectByKey(criteriaObjectFromServer, "ruleAttrKey");
    const value = retriveCriteriaObjectByKey(criteriaObjectFromServer, "ruleAttrVal");

    if(key && value){
      targetObject = {
        key: key.value[0],
        value: value.value,
        operation: value.operation
      }
    }
  }

  if (_.has(dataTableComponentData, "page")) {
    totalRecordCount = dataTableComponentData.page.totalElements;
  }

  function createDetailLink(data, type, row) {
    let newRender;

    newRender = render(detailLinkTemplate, {
      id: row.ruleId,
      name: row.ruleId,
      url: viewRulesDetailURL
    });
    return newRender;
  }

  const ruleLookup = new LookupTable({
    // REQUIRED - Set a target element
    target: $("#order-hold-rules-table-wrapper"),
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
      {
        data: "ruleId",
        title: "Release Rule ID",
        render: createDetailLink
      },
      {
        data: "sku",
        title: "Product SKU"
      },
      {
        data: "orderType",
        title: "Channel"
      },
      {
        data: "posLocation",
        title: "POS Location"
      },
      {
        data: "releaseDate",
        title: "Release Schedule"
      }
    ],
    // tableFilters: {
    //    data: orderFilterData,
    //  },
    tableSearch: true,
    // REQUIRED: search input info
    tableSearchInput: {
      // Not required
      // placeholder: 'Custom Search Text'
      value: targetObject != "" ? targetObject.value[0] : ""
    },
    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
    tableSearchDropdown: {
      selected: targetObject == "" ? "" : targetObject.key,
      columns: lookupFieldDropdown
    },
    newSavedViews: false,
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    bulkSelect: true,
    // REQUIRED - Data Table specific settings
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: dataTableComponentData.content,
      // Not required, just to show you can
      columnDefs: [{}],
      // Not required, just to show you can
      order: [[2, "desc"]],
      columns: [
        {
          data: "ruleId",
          render: renderActionWrap,
          orderable: false,
          class: "dtc-action-column",
          title: "Actions"
        },
        {
          data: "ruleId",
          title: "Release Rule ID",
          render: createDetailLink,
          class: "dtc-min-width-sm"
        },
        {
          data: "sku",
          orderable: false,
          title: "Product SKU",
          class: "dtc-min-width-md"
        },
        {
          data: "orderType",
          orderable: false,
          title: "Channel",
          class: "dtc-min-width-md"
        },
        {
          data: "posLocation",
          orderable: false,
          title: "POS Location",
          class: "dtc-min-width-md"
        },
        {
          data: "releaseDate",
          title: "Release Schedule",
          class: "dtc-min-width-md"
        }
      ]
    },
    //  tableColumnModal: {
    //	data: ruleLookupColumnsPopup
    //},
    paginationData: dataTableComponentData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Order Hold Rules",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "orderHold"
    },
    onBulkSelectChange: function() {
      selectedRows = ruleLookup.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass("disabled");
      } else {
        $(".action-header-btn .base-btn").addClass("disabled");
      }
    },
    onFetch: function() {
      let currentData = ruleLookup.generateData();
      ruleLookup.showLoadingOverlay();

      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
      if (isOnlyLookupDataUpdate(currentData)) {
        setTimeout(() => {
          doAjax({
            url: filterSearchUrl,
            success: filterSuccessFun,
            error: errorFun,
            data: prepareDataToSendController(currentData)
          });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isNew(currentData)) {
        setTimeout(() => {
          doAjax({
            url: saveViewURL,
            success: savedViewSuccess,
            error: errorFun,
            data: prepareDataToSendController(currentData)
          });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isEdit(currentData)) {
        setTimeout(() => {
          doAjax({
            url: saveViewURL,
            success: savedEditViewSuccess,
            error: errorFun,
            data: prepareDataToSendController(currentData)
          });
        }, SUCCESS_MODAL_TIMEOUT);
      } else if (isDeleteView(currentData)) {
        setTimeout(() => {
          doAjax({
            url: deleteViewURL,
            success: delteViewScussFun,
            error: errorFun,
            data: prepareDataToSendController(currentData)
          });
        }, SUCCESS_MODAL_TIMEOUT);
      }
    }
  });

  function filterSuccessFun(data) {
    let rules = data.content;
    let page = data.page;
    ruleLookup.setNewData(rules);
    ruleLookup.setPaginationData(page);
    pushFilterSessionCacheState();
    totalRecordCount = page.totalElements;
    ruleLookup.hideLoadingOverlay();
    setExportData(ruleLookup.generateData());
    //$(".data-table-component").DataTable().columns('.status-column').visible( false );
  }

  function savedViewSuccess(data) {
    let rules = data.lookupRuleJSON.content;
    let page = data.lookupRuleJSON.page;
    ruleLookup.setNewData(rules);
    ruleLookup.setPaginationData(page);
    ruleLookup.setNewSavedViewData(data.savedView, "newSavedView");
    pushFilterSessionCacheState();
    totalRecordCount = page.totalElements;
    ruleLookup.hideLoadingOverlay();
    setExportData(ruleLookup.generateData());
  }

  function savedEditViewSuccess(data) {
    let rules = data.lookupRuleJSON.content;
    let page = data.lookupRuleJSON.page;
    ruleLookup.setNewData(rules);
    ruleLookup.setPaginationData(page);
    ruleLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    pushFilterSessionCacheState();
    totalRecordCount = page.totalElements;
    ruleLookup.hideLoadingOverlay();
    setExportData(ruleLookup.generateData());
  }

  function delteViewScussFun(data) {
    let rules = data.lookupRuleJSON.content;
    let page = data.lookupRuleJSON.page;
    ruleLookup.removeSavedView(data.target);
    ruleLookup.setNewData(rules);
    ruleLookup.setPaginationData(page);
    totalRecordCount = page.totalElements;
    ruleLookup.hideLoadingOverlay();
    setExportData(ruleLookup.generateData());
  }

  function errorFun(data) {
    ruleLookup.hideLoadingOverlay();
  }

  ruleLookup.init();

  //const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
  function renderActionWrap(data, type, row, meta) {
    let newRender;
    let statusTarget = actionList["actions"];
    newRender = render(actionCellDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row),
      index: meta.row
    });
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionList["all"];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(actionHeaderDropdownTemplate, {
      list: renderActionCellList(statusTarget, data, row)
    });
    return newRender;
  }

  function renderActionCellList(list, data, row) {
    let renderedList = _(list).map(item => {
      return render(
        actionCellDropdownItemTemplate,
        neededActions(data, row, item)
      );
    });
    return renderedList.join("");
  }

  function neededActions(data, row, item) {
    var action = {
      icon: item.icon,
      title: item.title,
      cls: item.cls,
      disabled: item.disabled
    };
    return action;
  }

  function shallAllowClick(currentObj) {
    return !$(currentObj).hasClass("disabled");
  }

  $("body").on("click", ".release-rule", function(e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
      let pIndex = $(this)
        .closest(".dropdown-menu")
        .data("parent-index");
      // Get the row based on the parent...
      let parent = $(".dropdown-parent-" + pIndex).parents("tr");
      // Get the row data
      let row = $(".data-table-component")
        .dataTable()
        .api()
        .row(parent);

      if ($(this).hasClass("release-rule")) {
        processReleaseRule(row);
      }
    }
  });

  function processReleaseRule(row) {
    const submitModal = new SubmitModalFlow({
      confirmModalTitle: "Release Rule(s)",
      confirmModalBody: `<div class="q-marg-all-xl">
                          <div class="q-marg-vert-md">
                            Confirming the manual release of this rule(s) will trigger it's original release schedule, if applicable, to reset and to be released at the current time.
                          </div>
                          <div class="q-marg-vert-md">
                            Once released, all orders impacted by this rule(s) will begin to be processed. 
                          </div>
                        </div>`,
      confirmModalBtnText: "Release",
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function() {
        submitModal.showLoadingModal();
        let data = row.data();
        releaseRule(row, data);

        function releaseRule(row, rule) {
          $.ajax({
            url: releaseUrl,
            type: "POST",
            dataType: "JSON",
            data: {
              ruleId: rule.ruleId
            },
            success: function(data) {
              if (data.response == "success") {
                let d = row.data();
                d.releaseDate = data.cbrEffectiveEndDate;
                row.data(d).draw();
                submitModal.showSuccessModal();
                setTimeout(function() {
                  submitModal.hideAllModals();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              } else {
                submitModal.showFailureModal();
              }
            },
            error: function(data) {
              submitModal.hideAllModals();
            }
          });
        }
      }
    });
    submitModal.init();
    submitModal.showConfirmModal();
  }

  $("body").on("click", ".bulk-release-rule", function(e) {
    e.preventDefault();
    if (shallAllowClick(this)) {
      var submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Release Rule(s)",
        confirmModalBody: `<div class="q-marg-all-xl">
                            <div class="q-marg-vert-md">
                              Confirming the manual release of this rule(s) will trigger it's original release schedule, if applicable, to reset and to be released at the current time.
                            </div>
                            <div class="q-marg-vert-md">
                              Once released, all orders impacted by this rule(s) will begin to be processed. 
                            </div>
                          </div>`,
        confirmModalBtnText: "Release",
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          releaseRules();
          function releaseRules() {
            $.ajax({
              url: bulkReleaseRuleUrl,
              type: "POST",
              dataType: "JSON",
              data: {
                [`ruleIds`]: getAllSelectedRuleIds()
              },
              success: function(data) {
                if (data.response == "success") {
                  _(selectedRows).map(item => {
                    let currentRow = $(".data-table-component")
                      .DataTable()
                      .row(item.rowIndex);
                    var d = currentRow.data();
                    d.releaseDate = data.releaseDate;
                    currentRow.data(d).draw();
                  });
                  ruleLookup.uncheckAllSelected();
                  submitModalFlow.showSuccessModal();
                  setTimeout(function() {
                    submitModalFlow.hideAllModals();
                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
                } else {
                  submitModalFlow.showFailureModal();
                }
              },
              error: function(data) {
                submitModalFlow.hideAllModals();
              }
            });
          }
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

  function getAllSelectedRuleIds() {
    var ruleIds = new Array();
    _(selectedRows).map(item => {
      ruleIds.push(item.data.ruleId);
    });

    return ruleIds;
  }

  function initExport() {
		let exportObj  =  {
			title : $(targetSelector).data("export-popup-title"),
			exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
			exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
			exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
		};

		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportBasicURL(generateExportUrl,currentData);
		exportModal.setExportCount(currentData.totalElements);
	}

  initExport();
	setExportData(ruleLookup.generateData());

  // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
  handleCustomDropdownEvents();

  $("th.dtc-action-column").html(renderActionHeaderWrap());
});



// WEBPACK FOOTER //
// ./src/pages/orderHoldRules/lookup.js